import {ReactNode} from "react";
import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";

interface WarningProps {
	children: ReactNode;
}

const Box = styled.div`
	display: flex;
	min-height: 600px;
	text-align: center;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 30px;

	&:before {
		display: block;
		width: 60px;
		height: 60px;
		background: url(${SpriteImage}) 0 -44px / 400px 400px no-repeat;
		content: "";
	}

	p {
		font-size: 15px;
		color: var(--emp-color);
	}
`;

const WarningBox = ({children}: WarningProps) => (
	<Box>
		<p>{children}</p>
	</Box>
);

export default WarningBox;
